import Switch from "@/Components/Switch"
import { Inertia } from "@inertiajs/inertia"
import { Link } from "@inertiajs/inertia-react"
import { useState } from "react"

const BranchOfficeItem = (office) => {

    const [isActive, setIsActive] = useState(office.is_active);
    const [loadingToggle, setLoadingToggle] = useState(false);

    const handleToggle = async (value) => {
        setIsActive(value);
        setLoadingToggle(true);

        Inertia.post(route('branch-office.toggle', {office: office.slug}), office.slug, {
            onFinish: () => {
                setLoadingToggle(false);
            }
        });
    }

    return (
        <div className="gap-2 w-full bg-white shadow-sm sm:rounded-lg border-b border-gray-200 p-3 flex flex-col sm:flex-row sm:justify-between sm:items-center hover:bg-gray-200 hover:border-gray-300">
            <div className="flex-1">
                <p>{office.name}</p>
            </div>
            <div className="flex-1">
                <Switch value={isActive} onToggle={handleToggle} loading={loadingToggle} />
            </div>
            <div className="flex-1 flex sm:justify-end">
                <Link className="py-2 px-5 bg-black rounded text-white mr-5" href={route('branch-office.edit', office.slug)}> Editar</Link>
                <button className="px-3 py-2 rounded bg-accent text-white" onClick={() => {handleDelete(office)} }>eliminar</button>
            </div>
        </div>
    )
}

export default BranchOfficeItem